var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import styled from 'styled-components';
var SCROLL_OFFSET = -70;
export function ScrollingNav(_a) {
    var targets = _a.targets, _b = _a.navLinkClass, navLinkClass = _b === void 0 ? 'nav-link' : _b, _c = _a.activeLinkClass, activeLinkClass = _c === void 0 ? 'nav-target' : _c, containerClass = _a.containerClass;
    var _d = useState(), scrollTarget = _d[0], setScrollTarget = _d[1];
    useEffect(function () {
        function handleScroll(event) {
            try {
                event.stopPropagation();
                var sections = [];
                for (var _i = 0, targets_1 = targets; _i < targets_1.length; _i++) {
                    var target = targets_1[_i];
                    var section = document.getElementById(target.id);
                    if (section) {
                        sections.push(section);
                    }
                }
                var position = window.scrollY;
                var hit = false;
                for (var _a = 0, sections_1 = sections; _a < sections_1.length; _a++) {
                    var section = sections_1[_a];
                    var offset = section.offsetTop + SCROLL_OFFSET;
                    if (position >= offset) {
                        if (document.getElementById(section.id))
                            setScrollTarget(section.id);
                        hit = true;
                    }
                }
                if (window.innerHeight + position >= document.body.offsetHeight) {
                    if (document.getElementById(sections[sections.length - 1].id))
                        setScrollTarget(sections[sections.length - 1].id);
                }
            }
            catch (error) {
                console.log(error);
            }
        }
        window.addEventListener('scroll', handleScroll);
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    function updateTarget(id) {
        var _a;
        setScrollTarget(id);
        var pos = (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.offsetTop;
        if (typeof pos === 'number') {
            window.scrollTo({ top: pos + SCROLL_OFFSET, behavior: 'smooth' });
        }
    }
    return (_jsx(NavContainer, __assign({ className: containerClass }, { children: targets.map(function (t) { return (_jsx("p", __assign({ className: t.id === scrollTarget
                ? activeLinkClass + ' ' + navLinkClass
                : navLinkClass, onClick: function () { return updateTarget(t.id); } }, { children: t.label }), t.id)); }) }), void 0));
}
var NavContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  max-width: 100vw;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  max-width: 100vw;\n  flex-wrap: wrap;\n"])));
var templateObject_1;
